import {
  createAsyncThunk,
  createSlice,
  isRejectedWithValue,
} from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { routes } from "../../constants";
import Axios, { authHeaders } from "../../helpers/axios";

export const createRestaurant = createAsyncThunk(
  "createRestaurant",
  async (data, thunkAPI) => {
    try {
      const response = await Axios.post(
        `/onecity/restaurant`,
        data.data,
        authHeaders()
      );
      if (response.status === 200 || response.status === 201) {
        toast.success(data.toast, {
          autoClose: 3000,
        });
        data.navigate(`${routes.foodBeverage}`);
        return response.data;
      }
      return response.data;
    } catch (error) {
      toast.error(error.response.data.message, {
        autoClose: 3000,
      });
      return isRejectedWithValue(error.response.data.message);
    }
  }
);

export const getRestaurant = createAsyncThunk(
  "getRestaurant",
  async (data, thunkAPI) => {
    try {
      const response = await Axios.get(
        `/onecity/restaurant?restaurant_name=${data.restaurant_name || ""}`,
        authHeaders()
      );
      return response.data;
    } catch (error) {
      if (error.response.status === 403 && data.noAuthority) {
        toast.error(error.response.data.message, {
          autoClose: 3000,
        });
        return data.noAuthority(error.response.data);
      }
      toast.error(error.response.data.message, {
        autoClose: 3000,
      });
      return error.response.data.message;
    }
  }
);

export const updateRestaurant = createAsyncThunk(
  "updateRestaurant",
  async (data, thunkAPI) => {
    try {
      const response = await Axios.put(
        `/onecity/restaurant/${data.id}`,
        data.data,
        authHeaders()
      );
      if (response.status === 200 && !data.cb) {
        toast.success(data.toast, {
          autoClose: 3000,
        });
        data.navigate(`${routes.foodBeverage}`);
        return response.data;
      }
      if (data.cb) {
        toast.error(data.toast, {
          autoClose: 3000,
        });
        return data.cb(null, response.data);
      }
      // return response.data;
    } catch (error) {
      toast.error(error.response.data.message, {
        autoClose: 3000,
      });
      return isRejectedWithValue(error.response.data.message);
    }
  }
);

const foodBeverageSlice = createSlice({
  name: "foodBeverage",
  initialState: {
    restaurantList: [],
    createRes: "",
    error: null,
    loader: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    // Get Admin
    builder.addCase(getRestaurant.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(getRestaurant.fulfilled, (state, action) => {
      state.loader = false;
      state.restaurantList = action.payload;
    });
    builder.addCase(getRestaurant.rejected, (state, action) => {
      state.loader = false;
      state.error = action.payload;
    });

    // Create Restaurant
    builder.addCase(createRestaurant.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(createRestaurant.fulfilled, (state, action) => {
      state.loader = false;
      state.createRes = action.payload;
    });
    builder.addCase(createRestaurant.rejected, (state, action) => {
      state.loader = false;
      state.error = action.payload;
    });
  },
});

export default foodBeverageSlice.reducer;
